import React from "react";
import "./css/loggin.css";
// import { motion } from "framer-motion";

const Body =React.forwardRef((props, ref) => {
  return (
    <>
      <div
     
        className="imgDiv pt-5"
        // animate={{
        //   // x: 100,
        //   // y: 0,
        //   // rotate: 0,
        //   scale: 1,
        // }}
        // initial={{ scale: 2 }}
        // transition={{ duration: 0.8, delay: 0.3 }}
      >
        <img src="/images/style1.png" alt="Style Image" className="style1" />
        <img src="/images/style2.png" alt="Style Image" className="style2" />
        <img
          src="/images/groupimg.png"
          alt="Style Image"
          className="groupImg"
        />
      </div>
    </>
  );
});

export default Body;
